<template>
  <b-form-group
      :label="requiredField ? `Empresas*` : 'Empresas'"
      label-for="empresa"
      label-class="font_size_label"
  >
    <validation-provider #default="{ errors }" name="Empresa" :rules="rules">
      <div class="primary-select">
        <v-select
            id="empresa"
            :class="{ 'vs-uppercase-search': empresaFilter === 'doc_filter' }"
            :options="options"
            :value="displayValue"
            @input="handleInput"
            :placeholder="placeholder"
            :label="empresaFilter"
            :clearable="true"
            multiselect
            multiple
            :loading="loading"
            :disabled="loading || disabled || disabledField"
        >
          <template #list-header v-if="options.length > 0">
            <div class="vs__dropdown-option" @click="toggleSelectAll">
              <input type="checkbox" class="mr-1" :checked="isAllSelected" @click.stop="toggleSelectAll"/>
              <span>Selecionar Todas</span>
            </div>
          </template>
          <span slot="no-options">Nenhuma opção selecionável.</span>
          <template #option="item">
            <strong>{{item.documento_formatado}}</strong><br>
            <span v-if="empresaFilter !== 'doc_filter' && item[empresaFilter]">{{ item[empresaFilter] }}</span>
            <span v-else>{{ item.nome_empresa }}</span>
          </template>
          <template #selected-option="item">
            <span v-if="item.id_empresa === 'all'">
              {{ item.descricao }}
            </span>
            <span v-else>
              {{ empresaFilter !== 'doc_filter' ? item[empresaFilter] : item.documento_formatado }}
            </span>
          </template>
        </v-select>
      </div>
      <b-form-radio-group
          id="radio-group-empresa"
          v-model="empresaFilter"
          name="radio-sub-component"
          class="mt-10px radio-empresa"
          size="sm"
      >
        <span class="mr-1">Filtrar por:</span>
        <b-form-radio value="doc_filter">CNPJ/CPF</b-form-radio>
        <b-form-radio value="razao_social">Razão Social</b-form-radio>
        <b-form-radio value="nome_empresa">Nome Fantasia</b-form-radio>
      </b-form-radio-group>
      <small v-if="errors[0]" class="text-danger">
        {{ errors[0] }}
      </small>
    </validation-provider>
  </b-form-group>
</template>

<script>
import {
  BButton,
  BCol,
  BForm,
  BFormDatepicker,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormRadioGroup,
  BFormTextarea,
  BOverlay,
  BRow,
  BSpinner,
  BTable
} from "bootstrap-vue";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import vSelect from "vue-select";

import {getUserData} from "@/auth/utils";
import {TIPO_RELATORIO_ENUM} from "../config";

export default {
  components: {
    BForm,
    BCol,
    BRow,
    BFormGroup,
    BFormInput,
    BButton,
    BTable,
    BSpinner,
    BFormDatepicker,
    BFormTextarea,
    BOverlay,
    ValidationProvider,
    ValidationObserver,
    BFormRadioGroup,
    BFormRadio,
    vSelect,
  },
  props: {
    value: {
      required: true,
    },
    optionsConsulted: {
      required: false,
      type: Array,
      default: () => [],
    },
    idTipoRelatorio: {
      required: true,
      type: Number
    },
    disabled: {
      required: false,
      type: Boolean,
      default: false
    },
    filters: {
      required: false,
      type: Object,
      default: {}
    },
    departamento: {
      required: false,
      type: Object,
      default: null
    },
  },
  data() {
    return {
      empresaFilter: 'doc_filter',
      options: [],
      userData: getUserData(),
      selected: this.value,
      placeholder: "Carregando...",
      loading: true,
      disabledField: false,
      allSelected: false,
      parametros: {
        params: {
          paginacao: false,
          situacao_cadastro_parcial_nacional: this.idTipoRelatorio === TIPO_RELATORIO_ENUM.ADESAO_POR_EMPRESAS_BASE_NACIONAL_ID,
          empresa_base_nacional: this.idTipoRelatorio === TIPO_RELATORIO_ENUM.ADESAO_POR_EMPRESAS_BASE_NACIONAL_ID,
          empresa_possui_grupo: this.idTipoRelatorio === TIPO_RELATORIO_ENUM.ADESAO_POR_EMPRESAS_BASE_NACIONAL_ID,
          colunaOrdenar: "nome_empresa",
        },
      },
      companyRequiredReports: [
        TIPO_RELATORIO_ENUM.ADESAO_POR_EMPRESAS_CAMPANHA_ESTADUAL_ID,
        TIPO_RELATORIO_ENUM.ADESAO_UNIFICADO_ID,
        TIPO_RELATORIO_ENUM.COLABORADORES_VACINADOS_ID,
        TIPO_RELATORIO_ENUM.QUANTITATIVO_VACINACAO_ID,
        TIPO_RELATORIO_ENUM.COLABORADORES_CADASTRADOS_ID
      ],
      maxSelection: 5,
      selectedGroup: false,
      requiredField: false,
      rules: "",
    };
  },
  computed: {
    idGrupo() {
      let idGrupo = null
      if (this.idTipoRelatorio === TIPO_RELATORIO_ENUM.COLABORADORES_CADASTRADOS_ID && this.filters.id_grupo) {
        idGrupo = this.filters.id_grupo[0].id_grupo
      }
      return idGrupo
    },
    isAllSelected() {
      return this.allSelected || (this.selected && this.selected.length === this.options.length);
    },
    displayValue() {
      if (this.allSelected) {
        return [{
          id_empresa: 'all',
          descricao: `Todas (${this.options.length} empresas)`,
          documento_formatado: `Todas (${this.options.length} empresas)`,
          nome_empresa: `Todas (${this.options.length} empresas)`,
          razao_social: `Todas (${this.options.length} empresas)`,
          doc_filter: `Todas (${this.options.length} empresas)`
        }];
      }
      return this.selected;
    }
  },
  beforeMount() {
    this.setOptions();
    this.setRules();
  },
  methods: {
    async setOptions(group = false) {
      await this.$http
          .get(this.$api.empresaRelatorioExportacao(), this.setRequestParams())
          .then(({ data }) => {
            if((!this.selectedGroup && !group) || group){
              this.options = data.map((empresa) => {

                return {
                  id_empresa: empresa.id_empresa,
                  descricao: (this.verifyIfFildHasUfConcatenated() ? empresa.uf + ' - ' : '') + empresa.nome_empresa,
                  documento: empresa.documento,
                  documento_formatado: empresa.documento_formatado,
                  nome_empresa: empresa.nome_empresa,
                  razao_social: empresa.razao_social,
                  doc_filter: empresa.documento_formatado + ' ' + empresa.documento
                };
              });
            }

            this.loading = false;
          });
    },
    perfilAdminDN() {
      const profiles = this.userData.perfis.map(profile => profile.id_perfil);

      return (profiles.includes(this.$perfil.ADMIN_DN));
    },

    perfilSaudeDN() {
      const profiles = this.userData.perfis.map(profile => profile.id_perfil);

      return (profiles.includes(this.$perfil.SAUDE_DN));
    },

    verifyIfFildHasUfConcatenated() {

      if (this.idTipoRelatorio === TIPO_RELATORIO_ENUM.QUANTITATIVO_VACINACAO_ID) {
        return this.perfilAdminDN();
      }

      if (this.idTipoRelatorio === TIPO_RELATORIO_ENUM.COLABORADORES_VACINADOS_ID) {
        return this.perfilSaudeDN();
      }

      return false;
    },

    setRules() {
      if (this.companyRequiredReports.includes(this.idTipoRelatorio)) {
        this.requiredField = true
        this.rules = "required"
      }
    },

    setRequestParams() {
      if (this.idTipoRelatorio === TIPO_RELATORIO_ENUM.AGENDAMENTOS_ID) {
        this.parametros.params.tem_agendamento = true;
      }

      if (this.idTipoRelatorio === TIPO_RELATORIO_ENUM.COLABORADORES_CADASTRADOS_ID) {
        this.parametros.params.id_grupo = this.idGrupo;
      }

      if (this.idTipoRelatorio === TIPO_RELATORIO_ENUM.NPS_ID && this.departamento?.id_departamento) {
        this.parametros.params.id_departamento = this.departamento.id_departamento;
      }

      return this.parametros;
    },

    defaultEmpresaFilter() {
      this.$set(this, 'empresaFilter', 'doc_filter');
    },

    toggleSelectAll() {
      if (this.isAllSelected) {
        this.allSelected = false;
        this.selected = [];
      } else {
        this.allSelected = true;
        this.selected = [...this.options];
      }
    },
    handleInput(value) {
      if (!value || value.length === 0) {
        this.allSelected = false;
        this.selected = [];
      } else if (value.some(value => value.id_empresa === 'all')) {
        return;
      } else {
        this.allSelected = false;
        this.selected = value;
      }
    }
  },
  watch: {
    selected: function (valor) {
      this.$emit("selected", valor);
    },
    options: function (valor) {
      const noData = this.options.length === 0
      this.disabledField = noData
      this.placeholder = noData && !this.loading
          ? "Nenhum registro encontrado"
          : "Selecione a empresa";

      this.$emit("options", valor);
    },
    idGrupo: function (val) {
      if(val) {
        this.selected = [];
      }
      this.selectedGroup = !!val;
      this.options = [];
      this.loading = true;
      this.setOptions(true);
    },
    departamento: {
      deep: true,
      handler(novoDepartamento) {
        if (novoDepartamento && novoDepartamento.id_departamento) {
          this.loading = true;
          this.setOptions();
        }
      },
    },
  },
};
</script>

<style>
.radio-empresa .custom-radio.b-custom-control-sm .custom-control-label::before, [dir=ltr] .input-group-sm .custom-radio .custom-control-label::before {
  left: 0;
}

#empresa.vs-uppercase-search .vs__search:not(:placeholder-shown) {
  text-transform: uppercase;
}

#empresa.vs-uppercase-search .vs__search::placeholder {
  text-transform: none;
}
</style>
